import { vaultApi } from '@modules/vault/api';
import { KYCCountry } from '@huspy/forge/types';
import { useQuery } from '@tanstack/react-query';

const useKYCData = <TCountry extends KYCCountry = 'AE'>(opportunityId?: string | null) => {
  const {
    data, isLoading, error, refetch,
  } = useQuery({
    queryKey: ['kyc', opportunityId],
    queryFn: () => vaultApi.getKYCData<TCountry>(opportunityId!),
    enabled: !!opportunityId,
    staleTime: 1_800_000,
    retry(failureCount, err) {
      return !(err.statusCode === 403 || failureCount > 5);
    },
  });

  return {
    data: { kyc: data ?? {} },
    isLoading,
    error,
    refetch,
    isDisabled: error?.statusCode === 403,
  };
};

export default useKYCData;
